import * as Sentry from '@sentry/react';

import { isDev } from '~/dev/utils/isDev';

export const recordOpaqueContentTypeMetric = (contentType: string) => {
  if (isDev) {
    console.info(`[opaque content-type] ${contentType} → application/pdf`);
    return;
  }

  Sentry.startInactiveSpan({
    name: 'ui.document_download.opaque_content_type',
    op: 'metric.counter',
    attributes: {
      'sentry.op': 'metric.counter',
      'sentry.origin': 'manual.react.metrics',
      value: 1,
      metric_type: 'custom_counter',
      s3_content_type: contentType,
    },
  }).end();
};
